import { render, staticRenderFns } from "./superAdmin.vue?vue&type=template&id=5cac75a6&scoped=true"
import script from "./superAdmin.vue?vue&type=script&lang=js"
export * from "./superAdmin.vue?vue&type=script&lang=js"
import style0 from "./superAdmin.vue?vue&type=style&index=0&id=5cac75a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac75a6",
  null
  
)

export default component.exports